import React, {useState} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { RoleCard } from "../components/RoleCard";

const roleData = [
  { title: "Contractor", imgSrc: "Contractor.jpg" },
  { title: "Developer", imgSrc: "Developer.jpg" },
  { title: "Owner", imgSrc: "Owner.jpg" },
  { title: "Design Professional", imgSrc: "Design_prof.jpg" },
  { title: "Government Representative", imgSrc: "Government.jpg" },
  { title: "Public Schools", imgSrc: "Permit.jpg" },
];

function MainContent() {
  const [selectedRole, setSelectedRole] = useState("");

  const handleRoleSelection = (role) => {
    setSelectedRole(role);
    localStorage.setItem("selectedRole", role); // Save role to local storage
  };
  return (
    <section>
      <Container fluid className="text-center py-3 stream-line">
        <Row>
          <Col>
            {/* <div className="heading large-font fw-bold">
              Streamline Your Permit Process
            </div>
            <div className="sub-heading regular-font">
              No matter the scope of work, our easy-to-use portal helps you
              apply for and track permits.{" "}
            </div> */}
          </Col>
        </Row>
        <div>
          <h2 className="selectUser">Select Your Role</h2>
          <div className="d-flex justify-content-center">
            <div className="d-flex justify-content-between align-items-center flex-wrap card-wrapper">
              {roleData.map((card, index) => (
                <RoleCard
                  key={index}
                  imageUrl={card.imgSrc}
                  title={card.title}
                  onRoleSelect={handleRoleSelection}
                ></RoleCard>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default MainContent;
